import React, { useEffect, useMemo, useState } from 'react';

/**
 * Принимает src (оригинальную ссылку), вычисляет thumbUrl только один раз
 */
function getThumbUrl(originalUrl) {
  if (!originalUrl) return '';
  if (!originalUrl.includes('/uploads/') || originalUrl.includes('/uploads/thumbs/')) return originalUrl;

  const [prefix, fileName] = originalUrl.split('/uploads/');
  const extIndex = fileName.lastIndexOf('.');
  if (extIndex === -1) return originalUrl;

  const base = fileName.substring(0, extIndex);
  return `${prefix}/uploads/thumbs/${base}_thumb.jpg`;
}

function ThumbnailImage({ src, alt = '', onError, ...props }) {
  const thumbSrc = useMemo(() => getThumbUrl(src), [src]);
  const [current, setCurrent] = useState(thumbSrc);

  useEffect(() => { setCurrent(thumbSrc); }, [thumbSrc]);

  // Older photos may have no thumbnail yet: fall back to the original once.
  const handleError = (event) => {
    if (current !== src && src) setCurrent(src);
    onError?.(event);
  };

  return (
    <img
      src={current}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={handleError}
      {...props}
    />
  );
}

export default React.memo(ThumbnailImage);
